module.exports = __webpack_public_path__ + "f5c71f2a8d5194ae1e34d1ee567eae24.mp4";